module["exports"] = ["#{building_number} #{street_name}"];